<template>
    <div class="data-form-modal">

        <b-modal :size="size"
                 no-close-on-backdrop
                 body-class="light-bg"
                 :id="modalId"
                 @show="onShow">

            <template v-slot:modal-header>
                <h5>{{ title }}</h5>
            </template>

            <!-- slot for additional content -->

            <slot name="header"></slot>

            <b-form ref="form">

                <b-row :cols="$mq == 'sm' ? 1 : fieldGroups.length">
                    <!-- form inputs for specified fields, one group per column -->
                    <b-col v-for="(fieldGroup,i) in fieldGroups" :key="i">
                        <div class="frame p-3">
                            <data-form-input v-for="fieldName in fieldGroup" :key="fieldName"
                                             :horizontal="horizontal"
                                             :$v="$v"
                                             :form="form"
                                             :field-model="fieldModel"
                                             :field-name="fieldName"
                                             :model-instance="modelInstance">
                            </data-form-input>
                        </div>
                    </b-col>

                </b-row>

            </b-form>

            <!-- slot for additional content -->
            <slot name="footer"></slot>

            <template v-slot:modal-footer>
                <div class="float-left">
                    <slot name="modal-footer-extra"></slot>
                </div>
                <div class="float-right">
                    <b-btn class="btn-cancel ml-3 mr-2"
                           @click="cancelForm()">
                        <template v-if="$mq == 'sm'">
                            <b-icon icon="x"></b-icon>
                        </template>
                        <template v-else>
                            {{ $i18n.gt('LABEL_CANCEL') }}
                        </template>
                    </b-btn>

                    <b-btn variant="primary"
                           :disabled="$v.form && $v.form.$invalid"
                           @click="submitForm()">
                        <span v-if="$mq == 'sm'">
                            <b-icon icon="check"></b-icon>
                        </span>
                        <span v-else>
                            {{ saveButtonLabel }}
                        </span>
                    </b-btn>
                </div>
            </template>

        </b-modal>
    </div>
</template>

<script>

/**
 * A generic modal form for creating or updating an instance of a model, with validation.
 * Similar to DataForm, but with different submit actions.
 *
 * Requires a field model specifying the types and validation behaviors of the model's fields,
 * as well as a list of names of fields to display on the form
 * (these are not grouped as they are for DataForm).
 */

import Vue from 'vue'
import * as _ from 'lodash'
import Validation from '@/providers/Validation'
import {validationMixin} from 'vuelidate'

export default Vue.extend({
    name: 'DataFormModal',
    mixins: [validationMixin],
    props: {
        modalId: String,
        size: String, // sm / md / lg / xl
        title: String,
        horizontal: Boolean,
        saveButtonLabel: String,
        fieldGroups: Array,
        fieldModel: Object,
        modelInstance: Object,
        onCancelHandler: Function,
        onSubmitHandler: Function,
    },
    data() {
        // NB: must compute the flattened field list in advance rather than directly in the return structure!
        // (otherwise buildFormModel will be given an empty field list)
        const fieldList = _.flatten(this.fieldGroups)
        const form = Validation.buildFormModel(this.fieldModel, fieldList)

        return {
            fieldList: fieldList,
            form: form,
        }
    },
    validations() {
        return Validation.buildFormValidations(this.fieldModel, this.fieldList)
    },
    methods: {
        onShow(evt) {
            Validation.populateFormModel(this.form, this.fieldModel, this.modelInstance, this.fieldList)
        },
        cancelForm() {
            this.$bvModal.hide(this.modalId)
            if (this.onCancelHandler) {
                this.onCancelHandler()
            }
        },
        submitForm() {
            this.$v.form.$touch()
            if (this.$v.form.$anyError) {
                return
            } else {
                Validation.extractFormModel(this.$v.form, this.fieldModel, this.modelInstance, this.fieldList)
                this.$bvModal.hide(this.modalId)
                this.onSubmitHandler()
            }
        },
    },
})

</script>
